import noodleApiClient from '@/tsClient/servers/noodleApi';

/** A single field in the canonical data schema with its path and value type. */
type CanonicalSchemaField = {
  fieldPath: string;
  type: 'date' | 'number' | 'string';
};

/** Response from the canonical schema endpoint. */
type CanonicalSchemaResponse = {
  fields: CanonicalSchemaField[];
  version: number;
};

/** Fetches the canonical data schema (field paths and their types). */
const getCanonicalSchema = async (): Promise<CanonicalSchemaResponse> => {
  const response = await noodleApiClient.get('/cases/schema');
  return response.data as CanonicalSchemaResponse;
};

export type { CanonicalSchemaField, CanonicalSchemaResponse };
export default getCanonicalSchema;
